/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MailMagazineManagementShowMailMagazineResponse } from './MailMagazineManagementShowMailMagazineResponse';

export type MailMagazineManagementShowMailMagazineResponseApiRespoonse = {
    data?: MailMagazineManagementShowMailMagazineResponse;
    status?: MailMagazineManagementShowMailMagazineResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MailMagazineManagementShowMailMagazineResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

